module.exports = __webpack_public_path__ + "static/img/LUAMON-LUAL.5c0aea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUAMON-LUAL.jpg
// module id = 6bEG
// module chunks = 0